import {
  ApplicationTypeProductI,
  ValidationSet
} from '../../../../types/interface';
import { commonValidations } from '../validations';

export const applicationTypeOptionValidation: ValidationSet<{
  optionType: string;
  optionTypeGerman: string;
  productChangeValue: number[] | undefined;
  popupGetId: ApplicationTypeProductI[];
}> = {
  optionType: commonValidations.optionType,
  optionTypeGerman: commonValidations.optionTypeGerman,
  productChangeValue: commonValidations.productChangeValue,
  popupGetId: commonValidations.popupGetId
};
